import * as React from 'react';
export const routes = [
	// {
	// 	path: '/',
	// 	Component: React.lazy(() => import('../pages/MySite/SiteRouter')),
	// 	exact: true,
	// },
	{
		path: '/',
		Component: React.lazy(() => import('../pages/Dashboard')),
		exact: true,
	},
	{
		path: '/login',
		Component: React.lazy(() => import('../pages/Login')),
		exact: true,
	},
	{
		path: '/verifyOtp',
		Component: React.lazy(() => import('../pages/OTPVerify')),
		exact: true,
	},
	{
		path: '/projects',
		Component: React.lazy(() => import('../pages/Project')),
		exact: true,
	},
	{
		path: '/notifications',
		Component: React.lazy(() => import('../pages/Notification')),
		exact: true,
	},
	{
		path: '/sites',
		Component: React.lazy(() => import('../pages/MySite/SiteRouter')),
		exact: false,
	},
	{ 
		path: '/proect/details',
		Component: React.lazy(() => import('../pages/ProjectDetails')),
		exact: true,
	},
	// {
	// 	path: '/payments',
	// 	Component: React.lazy(() => import('../pages/Payments')),
	// 	exact: true,
	// },
	{
		path: '/contacts',
		Component: React.lazy(() => import('../pages/Contacts')),
		exact: true,
	},
	{
		path: '/users',
		Component: React.lazy(() => import('../pages/Users')),
		exact: true,
	},
	{
		path: '/lead',
		Component: React.lazy(() => import('../pages/Lead')),
		exact: true,
	},
	{
		path: '/site-visit',
		Component: React.lazy(() => import('../pages/SiteVisit')),
		exact: true,
	},
	{
		path: '/follow-up-details',
		Component: React.lazy(() => import('../pages/FollowUpDetails')),
		exact: true,
	},
		{
		path: '/follow-up',
		Component: React.lazy(() => import('../pages/FollowUpDetails/followUp')),
		exact: true,
	},
	

	{
		path: '/feedback',
		Component: React.lazy(() => import('../pages/Feedback')),
		exact: true,
	},
	{
		path: '/tickets',
		Component: React.lazy(() => import('../pages/Queries/queryRouter')),
		exact: false,
	},
{
        path: '/cp-registration-form',
        Component: React.lazy(() => import('../pages/ChannelPartner')),
        exact: false,
    },
    {
        path: '/thank-you-page',
        Component: React.lazy(() => import('../pages/ChannelPartner/submissionForm')),
        exact: false,
    },
	
]
